
export default function ComparisonPrimaryButton({ name='', href='', target='_blank' }) {
  
  const className="bg-crisp-50 text-crisp-700 hover:bg-crisp-100 mt-6 block w-full py-2 px-4 border border-transparent rounded-md text-sm text-center font-medium uppercase"

  return (
    <a href={href} target={target} className={className}>
      {name}
    </a>
  )
}
